<template>
  <a class="btn btn-plain position-relative d-flex green-api-toggler"
     v-if="panelEnabled"
     v-b-tooltip.hover
     :title="title"
     @click="toggleChatPanel">
    <MaxSvg v-if="platform === 'max'" class="svg-light"/>
    <TelegramSvg v-else-if="platform === 'telegram'" class="svg-light"/>
    <WhatsappSvg v-else-if="platform === 'whatsapp'" class="svg-light"/>
    <WazzupSvg v-else class="svg-wazzup svg-light"/>
    <span class="notification-bubble header-panel-bubble"
          v-if="counter > 0">
      {{ counter }}
    </span>
  </a>
</template>

<script setup>
import WazzupSvg from '@/assets/svg-vue/header/chat.svg'
import WhatsappSvg from "@/assets/svg-vue/crm/whatsapp.svg.vue"
import MaxSvg from '@/assets/svg-vue/crm/max.svg'
import TelegramSvg from '@/assets/svg-vue/calendar/menu_sms.svg'
import {capitalize, computed} from "vue"
import {useStore} from "vuex"

const store = useStore()

const props = defineProps({
  platform: {
    type: String,
    default: "whatsapp",
  }
})

const toggleChatPanel = () => {
  store.state.dom.rightPaneOpened = !store.state.dom.rightPaneOpened
  store.commit('clearPanelNotifications')
  store.commit('setMessengerPanelPlatform', store.state.dom.rightPaneOpened ? props.platform : null)
}

const counter = computed(() => store.state.crm.newPanelGreenApiNotifications)

const getters = store.getters

const greenAPIWhatsappPanelEnabled = computed(() => getters.greenAPIPanelEnabled)
const greenAPIMaxPanelEnabled = computed(() => getters.greenAPIMaxPanelEnabled)
const greenAPITelegramPanelEnabled = computed(() => getters.greenAPITelegramPanelEnabled)
const title = computed(() => capitalize(props.platform))

const panelEnabled = computed(() => {
  if(props.platform === "whatsapp") return greenAPIWhatsappPanelEnabled.value
  if(props.platform === "telegram") return greenAPITelegramPanelEnabled.value
  if(props.platform === "max") return greenAPIMaxPanelEnabled.value
  return false
})
</script>

<style scoped>
svg {
  width: 18px;
  height: 18px;
}
</style>
